<template>
  <TooltipDefault v-if="title" :id="id" :label="title" >
    <ButtonBase v-bind="$attrs" class="justify-center"><slot></slot></ButtonBase>
  </TooltipDefault>
  <ButtonBase v-else v-bind="$attrs" class="justify-center"><slot></slot></ButtonBase>
</template>
<script setup lang="ts">
defineOptions({
  inheritAttrs: false
});
import ButtonBase from '@/modules/Core/components/general/ButtonBase.vue'
import { generarUuid } from '@/modules/Core/usings/generales'
import TooltipDefault from './TooltipDefault.vue';
defineSlots<{
  default: () => unknown
}>();
const props = defineProps({
  title: {
    type: String,
    default: undefined
  }
})
const { title } = props
const id = generarUuid()
</script>
